/**
 * 매장 데모 페르소나 — 비로그인·매장미등록 사용자에게 6 기능 미리보기용 정적 시드.
 *
 * 컨셉: 평균 동네카페 (월 매출 ~3,200만, 직원 2명, 메뉴 18개) — 사장님이 자기 가게 투영하기 좋은 규모.
 * 각 스테이지에서 페이지별 demo 데이터 슬롯을 채워 나감.
 */

export const DEMO_STORE = {
  name: "예시카페 (데모)",
  region: "서울 강남구",
  monthly_revenue: 32_000_000,
  employee_count: 2,
  menu_count: 18,
  founded_year: 2024,
} as const;

export type DemoReason = "login" | "register_store";

export const DEMO_CTA: Record<DemoReason, { title: string; body: string; ctaText: string; ctaHref: string }> = {
  login: {
    title: "내 매장으로 보려면",
    body: "로그인하면 본인 매장 데이터로 채워집니다. 예시카페는 미리보기용입니다.",
    ctaText: "로그인하고 시작하기",
    ctaHref: "/login",
  },
  register_store: {
    title: "내 매장으로 보려면",
    body: "매장 등록(2분)만 끝나면 본인 데이터로 자동 채워집니다. 음료·디저트 표준 메뉴가 미리 깔려 있어요.",
    ctaText: "매장 등록 시작",
    ctaHref: "/store/setup",
  },
};
